// React
import React, { useState } from "react";

// Components
import ListCreatorModal from "../components/ListCreatorModal";
import ListHomeContainer from "../components/ListHomeContainer";

// EventifyAPI
import * as EventifyAPI from "../libs/EventifyAPI";

export default function ListsPage(appProps) {
  const [isListCreatorModalOpen, setIsListCreatorModalOpen] = useState(false);

  return (
    <div className="lists-page">
      <ListHomeContainer
        email={appProps.email}
        organizationid={appProps.organizationid}
        createNewListAction={() => {setIsListCreatorModalOpen(true);}}
      />

      <ListCreatorModal
        visible={isListCreatorModalOpen}
        onCancel={() => {setIsListCreatorModalOpen(false);}}
        email={appProps.email}
      />
    </div>
  );
}
